import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { DateService } from 'app/shared/date.service';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { AppSettings } from 'app/shared/app-settings';
//import { IMyOptions } from 'mydatepicker';
import  '@progress/kendo-angular-intl/locales/he/all';
import { FormGroup , FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { stringify } from '@angular/core/src/util';
import { AdminService } from '../../admin.service';
import { numberSymbols } from '@telerik/kendo-intl';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadProgressTextService } from '../../admin-progress.service';
import { debug } from 'util';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { IOved } from 'app/admin/interface/ioved.interface';
import { UserMessagesService } from '../../../shared/user-messages/user-messages.service';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { IOvedPeilut } from 'app/admin/interface/ioved-peilut.interface';
declare var require: any;


@Component({
  selector: 'app-peiluyot-admin-home',
  templateUrl: './peiluyot-admin-home.component.html',
  styleUrls: ['./peiluyot-admin-home.component.css']
})
export class PeiluyotAdminHomeComponent implements OnInit {
  moment = require("moment");

  get ms_zehut_error() { return this.ovedForm.get('ms_zehut'); }

  isOvedSearched:boolean=false;
  is_updated:boolean = false;
  is_Oved_Exists:boolean=false;
  ms_zehut_valid:boolean = true;
  showSearchOvedFields: boolean = false;
  deleteOved: boolean = false;

  ovedForm = this.fb.group({
    ms_zehut:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    addUpdateOved:[0]
  })
  constructor(
    private fb:FormBuilder,
    private route:ActivatedRoute,
    private router:Router,
    private _adminService:AdminService,
    private loadProgressTextService: LoadProgressTextService,
    private userMessagesService: UserMessagesService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    //this.userMessagesService.clearAll();
    
  }
  
  onMsZehutSearchChange(value:string){
    this.isOvedSearched = false;
  }

  getOvedDetails()
  {
    this.spinnerService.showSpinner();

    this._adminService.getOvedPeilut(this.ovedForm.value.ms_zehut).subscribe((res: ResultOfOperation<IOvedPeilut>) => {
      debugger;
      this.isOvedSearched = true;
      this.spinnerService.hideSpinner();
      if(res.isSuccess){        
        debugger;
        let oved: IOvedPeilut = res.data;
        oved.tr_leida = this.moment.utc(oved.tr_leida);
        sessionStorage.setItem("encryptedMsZehut",oved.ms_zehut.toString());
        console.log(oved.ms_zehut);
        oved.ms_zehut = this.ovedForm.value.ms_zehut;
        sessionStorage.setItem("oved", JSON.stringify(oved));//save IOved object in session and use it after redirect
        this.is_Oved_Exists = true;
        this.router.navigate(['admin/peiluyot-admin/peiluyot-admin-oved-details']);
      }
    else
    {   
      this.is_Oved_Exists = false;
    }},
      error=>{console.log(error);
      this.spinnerService.hideSpinner();
    })

  }

  validateOvedmsZehut(ms_zehut)
  {
    console.log(this.ms_zehut_error.errors);
    let valid_zehut = this.validatemsZehut(ms_zehut);
    if (valid_zehut) {
        this.ms_zehut_valid = true;
    }
    else {
        this.ms_zehut_valid = false;
        this.ovedForm.patchValue({ ms_zehut: "" });
        return;
    }
  }

  validatemsZehut(value) {

    if (value.length == 0)
        return false;
    console.log(value.length);


    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
        if (value.length == 10)
            first8 = value.substring(0, 9);
        else {
            if (value.length == 9)
                first8 = "0" + value.substring(0, 8);
            else
                first8 = "00" + value.substring(0, 8);
        }
        cifratBikoret = value.substring(value.length - 1);
        var checkDigits = 0 * 1;
        var temp = 0;
        var i = 0;

        for (i = 1; i <= 9; i++) {
            temp = first8.charAt(i - 1);
            checkDigits = temp * 1 + checkDigits * 1;
            if ((i % 2) == 1) {
                checkDigits = temp * 1 + checkDigits * 1;
                if (temp > 4)
                    checkDigits = checkDigits * 1 - 9;
            }
        }
        checkDigits = (10 - checkDigits % 10) % 10;
        result = (checkDigits * 1 == cifratBikoret * 1);
    }
    catch (e) { result = false; }
    if (value == "0")
        result = false;
    return result;
}

  onOperationChange(){
   let currentState = this.ovedForm.value.addUpdateOved;
   if(currentState==2)
   {
     this.is_updated=true;
   }
   else if(currentState==1)
   {
    this.is_updated=false;
    this.router.navigate(['admin/peiluyot-admin/peiluyot-admin-oved-details']);
   }
  }
  // updateOvedButton(){ 
  //   this.is_updated=true;
  //   if(!this.showSearchOvedFields){
  //     this.showSearchOvedFields=true;
  //      }
  //   else{this.showSearchOvedFields=false;
  // }
  showMsZehutInput()
    { 
      sessionStorage.removeItem("ovedDeleted");
      this.deleteOved = false;
      this.is_updated = true;
      this.showSearchOvedFields = true;
    }

  addOvedButton(){
    this.is_updated = false;
    this.router.navigate(['admin/peiluyot-admin/peiluyot-admin-oved-details']);
  }
  showOved(){
    this.router.navigate(['admin/peiluyot-admin/peiluyot-admin-oved-details']);
  }
  
  showMsZehutInputDeleteOved()
  {
    this.is_updated = true;
    this.deleteOved = true;
    sessionStorage.setItem("ovedDeleted","deleted")
    this.showSearchOvedFields = true;
  }

  deletetedEfes()
  {
    alert("מחיקת עובד")
  }

  back()
  {
    this.router.navigateByUrl("/admin");
    this.userMessagesService.clearAll();
  }
}
